import Velocity from 'velocity-animate';

const ANIMATE_SETTINGS = {
  mobileHA: true,
  duration: 500,
  easing: [0.77, 0.0, 0.175, 1.0], // [cubic bezier]
};

export default class Transition {
  constructor(props) {
    if (typeof props.prevState === 'undefined') {
      return;
    }
    if (props.prevState === props.newState) {
      return;
    }

    // Cleanup all current transitions
    Transition.cleanup(props.component);
    this.component = props.component;

    // What animation are we doing now?
    let promises = [];
    if (props.prevState && !props.newState) {
      promises = this.fadeOut(props.dropAnimation);
    } else {
      promises = this.fadeIn();
    }

    // When all animations are finishes, call the complete handler
    Promise.all(promises).then(props.complete);
  }

  static cleanup(component) {
    if (!component) {
      return;
    }
    Velocity(component, 'stop', true);
  }

  fadeIn() {
    Velocity.hook(this.component, 'height', '100%');

    return [Velocity(this.component, { opacity: 1 }, ANIMATE_SETTINGS)];
  }

  fadeOut(dropAnimation = false) {
    Velocity.hook(this.component, 'height', '100%');

    const resetValue = { opacity: 0 };

    if (dropAnimation) {
      resetValue['backgroundColor'] = '#409FFF';
      resetValue['backgroundColorAlpha'] = 0.8;
      Velocity(
        this.component,
        {
          backgroundColor: '#7fbaff',
          backgroundColorAlpha: 0.9,
        },
        { ...ANIMATE_SETTINGS, duration: 350 }
      );
    }

    return [
      Velocity(this.component, resetValue, {
        complete: () => Velocity.hook(this.component, 'height', '0'),
        ...ANIMATE_SETTINGS,
      }),
    ];
  }
}
